import { BaseHandler } from './base-handler.js';

export class SelectionFieldHandler extends BaseHandler {
  getWrapper(): Element | null {
    if (this.el.closest('.group-selection')) {
      return this.el.closest('.group-selection');
    }
    return super.getWrapper();
  }
}
